import axios from 'axios';

import apiClient from '../../services/apiClient';




// Create new map detail
const createMap = async (mapData) => {
	
	const response = await apiClient.post('/api/maps/', mapData,);

	return response.data;
};

// Get all map
const getAllMaps = async () => {
	 

	const response = await apiClient.get('/api/maps/');
	return response.data;
};
// Get all map under failure check
const getAllFailedCheck = async () => {
	const response = await apiClient.get('/api/maps/failedcheck');
	return response.data;
};
// Get all map under failure check
const getAllFailed = async () => {
	
	const response = await apiClient.get('/api/maps/failed');
	return response.data;
};

// get all under type check
const getAllTypeCheck = async () => {
	
	const response = await apiClient.get('/api/maps/typecheck');
	
	return response.data;
};

// get all under type check 
const getAllUnitCheck = async () => {
	 

	const response = await apiClient.get(`/api/maps/unitcheck`);
	return response.data;
};
// get all under type check 
const getAllPassed = async () => {
	const response = await apiClient.get(`/api/maps/successful`);
	return response.data;
};
// Get single map
const getMap = async (mapId) => {
	

	const response = await apiClient.get(`/api/maps/` + mapId);

	return response.data;
};

// Delete single  map detail
const deleteMap = async (mapId) => {

	const response = await axios.delete(`/api/maps/` + mapId);

	return response.data;
};
// edit single map datail
const updateMap = async (mapId) => {
	
	const response = await apiClient.put(`/api/maps/successful` + mapId);

	return response.data;
};

const mapsService = {
	createMap,
	getAllMaps,
	deleteMap,
	updateMap,
	getMap,
	getAllFailedCheck,
	getAllTypeCheck,
	getAllUnitCheck,
	getAllFailed,
	getAllPassed
};

export default mapsService;
